import React from 'react'

import * as S from './styled'

const MostWantedCard = ({ mostWanted, negotiationCode }) => {
  const {
          exam_name,
          covered_health_insurance,
          exam_link,
          exam_price
        } = mostWanted

  const handleTag = (eventLabel) => {
    if (window && window.dataLayer)
      window.dataLayer.push({
        event: 'busca_exames',
        action: 'clicou_exame',
        exame: eventLabel
    })
  }

  return (
    <S.MainContainer id='MainContainer-div' data-testid='MainContainer-div'>
      <S.ContainerMostWantedCard
        id='ContainerMostWantedCard-a'
        data-testid='ContainerMostWantedCard-a'
        href={ exam_link }
        onClick={() => handleTag( exam_name )}
      >
        <S.ContainerMostWantedCardTitle
          id='ContainerMostWantedCardTitle-div'
          data-testid='ContainerMostWantedCardTitle-div'
        >
          <S.MostWantedCardTitle id='MostWantedCardTitle-h3' data-testid='MostWantedCardTitle-h3'>
            { exam_name }
          </S.MostWantedCardTitle>
        </S.ContainerMostWantedCardTitle>
        <S.MostWantedCardTag
          id='MostWantedCardTag-div'
          data-testid='MostWantedCardTag-div'
          covered_health_insurance={ covered_health_insurance }
        >
          <S.MostWantedCardTagText id='MostWantedCardTagText-p' data-testid='MostWantedCardTagText-p'>
            { covered_health_insurance ? 'Coberto por convênios' : 'Particular' }
          </S.MostWantedCardTagText>
        </S.MostWantedCardTag>
        <S.MostWantedCardValueTitle id='MostWantedCardValueTitle-p' data-testid='MostWantedCardValueTitle-p'>
          Particular a partir de
        </S.MostWantedCardValueTitle>
        <S.MostWantedCardValue id='MostWantedCardValue-p' data-testid='MostWantedCardValue-p'>
          {exam_price.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
        </S.MostWantedCardValue>
        <S.ContainerMostWantedCardInfo
          id='ContainerMostWantedCardInfo-div'
          data-testid='ContainerMostWantedCardInfo-div'
          data-item-text='Saiba mais'
          data-item-position='Módulo Exames'
          data-current-service='Home'
        >
          <S.MostWantedCardInfo id='MostWantedCardInfo-p' data-testid='MostWantedCardInfo-p'>
            Saiba mais
          </S.MostWantedCardInfo>
          <S.ArrowIconSoft  id='ArrowIconSoft-svg' data-testid='ArrowIconSoft-svg' fill='red' />
        </S.ContainerMostWantedCardInfo>
      </S.ContainerMostWantedCard>
    </S.MainContainer>
  )
}

export default MostWantedCard
